/* eslint-disable */
/**
 * Auto generated version file, do not modify it!
 */
const version = '1.30.2';
export { version };
//# sourceMappingURL=version.js.map